import { Default, Detail, List, Create, SplitRecord } from './views'
import { Previewer } from './wizards'

const Module = {
    name: "cashflowrecords",
    defaultRoutePath: "/cashflows/cashflowrecord",
    menuItemScope: "cashflows",
    menuItemName: "cashflowrecords",
    routes: [
        {
            path: "/cashflows/cashflowrecord",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "create",
            Component: Create,
        },
        {
            path: "splitRecord",
            Component: SplitRecord,
        },
        {
            path: 'preview',
            Component: Previewer
        }
    ]
}

export default Module
